<template>
  <router-link :to="logoLink">
    <svg width="120" height="40" viewBox="0 0 120 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M115.783 16.8584L111.245 12.3265H104.908V19.348H108.757V32.1484H104.318V39.1699H119.943V32.1484H115.783V16.8584Z" fill="#00C962"/>
      <path d="M87.976 4.60516C87.976 2.28829 89.8938 0.416626 92.1686 0.416626C94.4433 0.416626 96.4055 2.28829 96.4055 4.60516C96.4055 6.92203 94.532 8.79368 92.1686 8.79368C89.8051 8.79368 87.976 6.92203 87.976 4.60516Z" fill="#051C2C"/>
      <path d="M83.4949 12.3466H73.8348L68.1478 20.1189L62.4587 12.3466H52.9072L63.1038 26.1769L52.7986 39.15H62.5119L68.201 31.8605L73.8902 39.15H83.5481L73.2982 26.1769L83.4949 12.3466Z" fill="#051C2C"/>
      <path d="M86.1556 12.3466V19.368H89.6654V32.1286H86.1556V39.15H96.6959V12.3466H86.1556Z" fill="#051C2C"/>
      <path d="M39.7241 12.3465V15.0266C38.651 13.578 36.0215 11.7573 32.4253 11.7573C25.3948 11.7573 19.9761 18.1365 19.9761 25.7494C19.9761 33.3622 25.397 39.7414 32.4253 39.7414C36.0215 39.7414 38.651 37.9185 39.7241 36.4721V39.1522H50.1912V32.1285H46.6815V19.3702H50.1912V12.3465H39.7241ZM34.2522 32.3965C30.6028 32.3965 28.1351 29.6101 28.1351 25.7494C28.1351 21.8886 30.6028 19.1 34.2522 19.1C37.9016 19.1 40.3693 21.8886 40.3693 25.7471C40.3693 29.6056 37.9016 32.3965 34.2522 32.3965Z" fill="#051C2C"/>
      <path d="M12.0255 5.49561H4.99722V12.3465H0.336792V19.368H4.99722L5.00165 30.7663C5.00165 35.7212 8.59563 39.5155 13.5177 39.5155C15.9122 39.5155 17.054 39.2608 17.5218 39.1567V32.6136C17.2691 32.6491 16.2204 32.7421 15.2493 32.6845C14.5021 32.638 13.8924 32.5295 13.4135 32.2282C12.4668 31.6324 12.0278 30.4607 12.0278 28.7706V19.368H18.116V12.3465H12.0278V5.49561H12.0255Z" fill="#051C2C"/>
    </svg>
  </router-link>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();

// 計算 logo 導向的連結
const logoLink = computed(() => {
  return route.path.startsWith('/admin') ? '/admin/dashboard' : '/';
});
</script>
